import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { withTheme } from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Icon from '@mlb/react-patterns/components/Icon/icon';
import Link from '@mlb/react-patterns/components/Link/link';

import changeViewAction from '../../app/lib/store/actions/views';
import useTracking from '../../utils/hooks/useTracking';
import { useTranslate } from '../../utils//hooks/useTranslate';

import getInningTranslations from '../PlayFeed/utils/translatedInnings';
import { makeInningHeader } from '../PlayFeed/PlayFeed';
import SummaryPlays from './summaryPlayList/SummaryPlays';
import {
    EmptySummaryText,
    EmptySummaryWrapper,
    SummaryPlayListWrapper,
    VideoButtonDivider,
    VideoButton
} from './SummaryPlayList.style';

const SummaryPlayList = ({
    playsByInning = [],
    isLoading = false,
    filters = {},
    openAtBatOverlay,
    parallaxAdIndex,
    showVideoButton = true
}) => {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const Tracking = useTracking();
    const topText = translate('game_status_top', 'Top');
    const bottomText = translate('game_status_bottom', 'Bottom');
    const emptyText = translate('filter_empty_message', 'Sorry, no plays were found. Please try another filter.');
    const inningTranslations = getInningTranslations();
    const buttonText = translate('button_video_all', 'See all videos for this Game');
    const handleSeeAllClick =  useCallback((e) => {
        const cfg = {
            componentName: ['Summary'],
            text: 'See All',
            activity: 'View All Videos Click'
        };

        Tracking.track.track_click(cfg);
        Tracking.track.track_pageload();

        dispatch(changeViewAction({
            game_tab: 'video',
            detail: '',
            updateRoute: true
        }));
        if (typeof window !== 'undefined') {
            window.scrollTo(0,0);
        }
    }, [dispatch, changeViewAction, Tracking]);

    const viewAllHandlers = useMemo(() => ({
        onClick: handleSeeAllClick
    }), [handleSeeAllClick]);

    return (playsByInning.length === 0 && !showVideoButton ? (
        <SummaryPlayListWrapper>
            <EmptySummaryWrapper>
                <Icon name='sad-baseball' fill={COLORS.mlbGrey3} width={ 57 } />
                <EmptySummaryText>{emptyText}</EmptySummaryText>
            </EmptySummaryWrapper>
        </SummaryPlayListWrapper>) : (
        <SummaryPlayListWrapper>
            {
                playsByInning.map((playsObj, i) => {
                    const {
                        top = [],
                        bottom = [],
                        inning = i + 1
                    } = playsObj;

                    const inningTranslation = inningTranslations[inning];

                    return (<React.Fragment key={`inning-${i}`}>
                        { makeInningHeader(topText, inningTranslation, isLoading, top.length) }
                        { top.length ? <SummaryPlays parallaxAdIndex={parallaxAdIndex} openAtBatOverlay={ openAtBatOverlay } playArr={ top } filters={filters} /> : null }
                        { makeInningHeader(bottomText, inningTranslation, isLoading, bottom.length) }
                        { bottom.length ? <SummaryPlays parallaxAdIndex={parallaxAdIndex} openAtBatOverlay={ openAtBatOverlay } playArr={ bottom } filters={filters} /> : null }
                    </React.Fragment>);
                })
            }
            {(playsByInning.length !== 0 && showVideoButton) && <VideoButtonDivider/>}
            { showVideoButton && 
                <Link label={buttonText} handlers={viewAllHandlers}>
                    <VideoButton>{buttonText}</VideoButton> 
                </Link>
            }
        </SummaryPlayListWrapper>
    ));
};

SummaryPlayList.propTypes = {
    playsByInning: PropTypes.arrayOf(PropTypes.object),
    filters: PropTypes.object,
    isLoading: PropTypes.bool,
    openAtBatOverlay: PropTypes.func,
    parallaxAdIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    showVideoButton: PropTypes.bool
};

export default withTheme(SummaryPlayList);
